/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Insurance configuration details
 * @export
 * @interface LoanInsuranceConfigDto
 */
export interface LoanInsuranceConfigDto {
    /**
     * 
     * @type {string}
     * @memberof LoanInsuranceConfigDto
     */
    borrowerLoanId: string;
    /**
     * Insurance quota percentage
     * @type {number}
     * @memberof LoanInsuranceConfigDto
     */
    quota: number;
    /**
     * Insurance deductible amount
     * @type {number}
     * @memberof LoanInsuranceConfigDto
     */
    deductible: number;
    /**
     * Indicates if it's a capital insurance
     * @type {boolean}
     * @memberof LoanInsuranceConfigDto
     */
    isCapital: boolean;
    /**
     * Borrower role identifier
     * @type {string}
     * @memberof LoanInsuranceConfigDto
     */
    borrowerRoleId: string;
    /**
     * Option for psychological file buyback
     * @type {boolean}
     * @memberof LoanInsuranceConfigDto
     */
    isPsyBuyback: boolean;
    /**
     * Indicates if contribution exemption is active
     * @type {boolean}
     * @memberof LoanInsuranceConfigDto
     */
    isContribExempt: boolean;
    /**
     * Indicates if the configuration is active
     * @type {boolean}
     * @memberof LoanInsuranceConfigDto
     */
    isActive: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof LoanInsuranceConfigDto
     */
    guaranteeIds: Array<string>;
}

/**
 * Check if a given object implements the LoanInsuranceConfigDto interface.
 */
export function instanceOfLoanInsuranceConfigDto(value: object): value is LoanInsuranceConfigDto {
    if (!('borrowerLoanId' in value) || value['borrowerLoanId'] === undefined) return false;
    if (!('quota' in value) || value['quota'] === undefined) return false;
    if (!('deductible' in value) || value['deductible'] === undefined) return false;
    if (!('isCapital' in value) || value['isCapital'] === undefined) return false;
    if (!('borrowerRoleId' in value) || value['borrowerRoleId'] === undefined) return false;
    if (!('isPsyBuyback' in value) || value['isPsyBuyback'] === undefined) return false;
    if (!('isContribExempt' in value) || value['isContribExempt'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('guaranteeIds' in value) || value['guaranteeIds'] === undefined) return false;
    return true;
}

export function LoanInsuranceConfigDtoFromJSON(json: any): LoanInsuranceConfigDto {
    return LoanInsuranceConfigDtoFromJSONTyped(json, false);
}

export function LoanInsuranceConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoanInsuranceConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'borrowerLoanId': json['borrowerLoanId'],
        'quota': json['quota'],
        'deductible': json['deductible'],
        'isCapital': json['isCapital'],
        'borrowerRoleId': json['borrowerRoleId'],
        'isPsyBuyback': json['isPsyBuyback'],
        'isContribExempt': json['isContribExempt'],
        'isActive': json['isActive'],
        'guaranteeIds': json['guaranteeIds'],
    };
}

export function LoanInsuranceConfigDtoToJSON(json: any): LoanInsuranceConfigDto {
    return LoanInsuranceConfigDtoToJSONTyped(json, false);
}

export function LoanInsuranceConfigDtoToJSONTyped(value?: LoanInsuranceConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'borrowerLoanId': value['borrowerLoanId'],
        'quota': value['quota'],
        'deductible': value['deductible'],
        'isCapital': value['isCapital'],
        'borrowerRoleId': value['borrowerRoleId'],
        'isPsyBuyback': value['isPsyBuyback'],
        'isContribExempt': value['isContribExempt'],
        'isActive': value['isActive'],
        'guaranteeIds': value['guaranteeIds'],
    };
}

